import React from "react";
import { LoadingWrapper, Icon } from "./style";

const Loading = () => {
    return <LoadingWrapper>
        <Icon/>
    </LoadingWrapper>;
};

export default Loading;
